module.exports = __webpack_public_path__ + "assets/img/00153.8524f120.png";